import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transactionModal: false,
  txStatus: null,
  connectModal: false,
  walletSubmitModal: false,
  termsModal: false,
  termsAccepted: false,
};

export const ModalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setTxPending: (state) => {
      state.transactionModal = true;
      state.txStatus = null;
    },
    setTxConfirmed: (state) => {
      state.transactionModal = true;
      state.txStatus = true;
    },
    setTxFailed: (state) => {
      state.transactionModal = true;
      state.txStatus = false;
    },
    setTxModalClose: (state) => {
      state.transactionModal = false;
      // state.txStatus = null;
    },
    setConnectModal: (state, action) => {
      state.connectModal = action.payload;
    },
    setWalletSubmitModal: (state, action) => {
      state.walletSubmitModal = action.payload;
    },
    setTermsModal: (state, action) => {
      state.termsModal = action.payload;
    },
    setTermsAccepted: (state, action) => {
      state.termsAccepted = action.payload;
    },
  },
});

export const {
  setTxPending,
  setTxConfirmed,
  setTxFailed,
  setTxModalClose,
  setConnectModal,
  setWalletSubmitModal,
  setTermsModal,
  setTermsAccepted,
} = ModalSlice.actions;

export default ModalSlice.reducer;
